import React from "react";
import { InterventionGroup } from "../../../../../../store/onboarding/cases/types";
import { bindActionCreators, Dispatch } from "redux";
import { changeSelectedMeeting } from "../../../../../../store/onboarding/meeting-module/actions";
import { connect } from "react-redux";
import { changeSelectedInterventionGroup } from "../../../../../../store/onboarding/cases/actions";
import { push } from "connected-react-router";
import { Meeting } from "../../../../../../store/onboarding/meeting-module/types";
import InterventionGroupTeacher from "../common/InterventionGroupTeacher";
import { UserAssignmentRole } from "../../../../../../store/auth/types";
import { getFullName } from "../../../../../../utils/NamesUtils";

type DispatchProps = {
  push: (location: string) => any;
  changeSelectedInterventionGroup: (
    interventionGroup: InterventionGroup
  ) => any;
  changeSelectedMeeting: (meeting?: Meeting) => any;
};

type OwnProps = {
  interventionGroup?: InterventionGroup;
  onInterventionSkip: () => void;
  userRole?: UserAssignmentRole;
};

type Props = OwnProps & DispatchProps;

const ImplementationStageInfo = ({
  interventionGroup,
  userRole,
  push,
  onInterventionSkip,
  changeSelectedInterventionGroup,
  changeSelectedMeeting,
}: Props) => {
  if (!interventionGroup) return null;

  if (
    userRole === UserAssignmentRole.TEACHER ||
    userRole === UserAssignmentRole.SUPERVISOR
  ) {
    return (
      <div
        className="interventionInfoContainer"
        onClick={(e) => e.stopPropagation()}
      >
        <h4 className="font-weight-bold text-center">
          Waiting for{" "}
          {getFullName(interventionGroup.coach_assignment?.user) ?? "coach"} to
          meet with{" "}
          {userRole === UserAssignmentRole.SUPERVISOR
            ? getFullName(interventionGroup.teacher_assignment?.user)
            : "you"}
        </h4>
      </div>
    );
  }

  const onInterventionMeet = () => {
    changeSelectedInterventionGroup(interventionGroup);
    changeSelectedMeeting(interventionGroup.latest_meeting);
    push(`/cases/groups/${interventionGroup.id}/meeting`);
  };

  return (
    <div
      className="interventionInfoContainer"
      onClick={(e) => e.stopPropagation()}
    >
      <h4 className="font-weight-bold">
        You're all prepped, now meet with&nbsp;
        <InterventionGroupTeacher interventionGroup={interventionGroup} />
      </h4>
      <div className="d-flex justify-content-around mt-2">
        <button className="blueBtnSm mx-3" onClick={onInterventionMeet}>
          Meet
        </button>
        <button className="blueBtnSm mx-3" onClick={onInterventionSkip}>
          Skip
        </button>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => {
  return bindActionCreators(
    {
      changeSelectedInterventionGroup: changeSelectedInterventionGroup,
      changeSelectedMeeting: changeSelectedMeeting,
      push: push,
    },
    dispatch
  );
};

export default connect(null, mapDispatchToProps)(ImplementationStageInfo);
